import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { fetchTournamentById } from '../../api/api';
import LeagueView from './LeagueView';
import TourCurForm from '../TourCurForm/TourCurForm';
import Spinner from '../Spinner/Spinner';
import styles from '../TourCurForm/TourCurForm.module.css';

const competitionSystemMapping = {
    ROUND_ROBIN: 'Każdy z każdym',
    KNOCKOUT: 'Pucharowy',
    BRAZILIAN: 'Brazylijski do dwóch przegranych',
    BRAZILIAN_FAST: 'Brazylijski szybki',
    COMBINED: 'Faza grupowa + faza finałowa',
    GROUP_LEAGUE: 'Liga grupowa'
};

const LeagueViewPage = () => {
    const { tournamentId } = useParams();
    const navigate = useNavigate();
    const [tournament, setTournament] = useState(null);
    const [error, setError] = useState(null);

    // „Liga-link" z konfiguracji może wskazywać dowolny turniej — nie tylko GROUP_LEAGUE
    // (np. playoff COMBINED po sezonie ligowym). Najpierw pytamy o sam turniej, a widok
    // dobieramy po jego systemie rozgrywek: liga grupowa ma własny LeagueView, każdy inny
    // system oglądany jest przez TourCurForm — tak samo jak z listy turniejów.
    useEffect(() => {
        const load = async () => {
            const result = await fetchTournamentById(tournamentId);
            if (result.success && result.data) {
                setTournament(result.data);
            } else {
                setError('Nie znaleziono turnieju.');
            }
        };
        load();
    }, [tournamentId]);

    if (error) return <div style={{ padding: 20, textAlign: 'center' }}>{error}</div>;
    if (!tournament) return <Spinner size="large" />;

    const isArchived = tournament.status === 'COMPLETED';
    const handleReturn = () => navigate('/tournaments');

    if (tournament.competitionSystem !== 'GROUP_LEAGUE') {
        if (tournament.status !== 'ACTIVE' && tournament.status !== 'COMPLETED') {
            return <div style={{ padding: 20, textAlign: 'center' }}>Turniej jeszcze się nie rozpoczął.</div>;
        }
        return <TourCurForm tournament={tournament} isArchived={isArchived} onReturn={handleReturn} />;
    }

    return (
        <div className={styles.container}>
            <div className={styles.backRow}>
                <button className={styles.returnCurButton} onClick={handleReturn}>
                    ← Powrót
                </button>
            </div>
            <div className={styles.header}>
                <div className={styles.title}>{tournament.title}</div>
            </div>
            <div className={styles.metaLine}>
                <a href="/competition-descriptions" target="_blank" rel="noreferrer"
                   className={styles.metaSystem}>
                    {competitionSystemMapping[tournament.competitionSystem]}
                </a>
                {!isArchived &&
                    <>
                        <span className={styles.metaDot}></span>
                        <a href="/score-rules" target="_blank" rel="noreferrer"
                           className={styles.metaLink}>Zasady gry</a>
                    </>
                }
            </div>
            <LeagueView
                tournament={tournament}
                isArchived={isArchived}
                onReturn={handleReturn}
            />
        </div>
    );
};

export default LeagueViewPage;
